<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jwfGnM/images/9781439105085_cover.jpg?1730635551197" alt="This image is the cover for the book Death on a Vineyard Beach, Martha's Vineyard Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death on a Vineyard Beach, Martha's Vineyard Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>When J.W. Jackson foils an attempt to terminate former mob boss Luciano Marcus on the steps of Boston’s Symphony Hall, it puts a definite damper on Jackson and Zee’s newlywedded bliss, especially when the mayhem follows them back home to Martha’s Vineyard. Keeping circling sharks from the kill might be more than J.W. can handle.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip R. Craig
      </h2>
      
      <p class="authorDescription body article">The late Philip R. Craig was the author of nineteen novels in the Martha&rsquo;s Vineyard Mystery series. A professor emeritus of English at Wheelock College in Boston, he loved the Vineyard and lived there year-round with his wife, Shirley.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scribner
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48df486a